import { superCodeActions } from '../../services';


export const superCodeDispatcher = dispatch => ({
  createSuperCode: createdSupercodeResponse => dispatch( { type: superCodeActions.CREATE, data: createdSupercodeResponse  } ),

  identify: identifiedSupercodeResponse => dispatch( { type: superCodeActions.IDENTIFY, data: identifiedSupercodeResponse } ),

  saveToSap: saveToSapResponse => dispatch( { type: superCodeActions.SAVETOSAP, data: saveToSapResponse } )
});